import { Navigate } from 'react-router-dom';

export default function ParentDashboard() {
  return <Navigate to="/dashboard/calendar" replace />;
}
